import { render, staticRenderFns } from "./PDFJS.vue?vue&type=template&id=1dfafd9a&"
import script from "./PDFJS.vue?vue&type=script&lang=js&"
export * from "./PDFJS.vue?vue&type=script&lang=js&"
import style0 from "./PDFJS.vue?vue&type=style&index=0&id=1dfafd9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports